import React from 'react'
import List from './List'
import { useDistributionCreatedUpdatedById } from 'src/queries'

interface BodyProps {
  id: string
}

const Body: React.FC<BodyProps> = (props) => {
  const { id } = props
  const distribution = useDistributionCreatedUpdatedById(id)
  return (
    <List distribution={distribution} />
  )
}

export default Body
